import useReveal from "../../hooks/useReveal";

export default function About({ profile }) {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const ref = useReveal();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-[#0D0D0D] text-[#EAEAEA] py-20 md:py-28 overflow-hidden"
    >
      {/* Vertical label */}
      <div className="hidden lg:block absolute top-1/2 left-6 -translate-y-1/2 -rotate-90 origin-left">
        <span className="font-mono-overline text-[#C4A27A] tracking-[0.4em]">
          About — 00 / Nadeer Hashmi
        </span>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-start">
        {/* Pull quote takes the lead — like a magazine opener */}
        <div ref={ref} className="reveal md:col-span-12 mb-2">
          <div className="flex items-baseline gap-4 mb-6">
            <span className="font-mono-overline text-[#C4A27A]">A note from</span>
            <span className="w-16 h-px bg-[#C4A27A]/40" />
            <span className="font-mono-overline text-[#EAEAEA]/40">The desk</span>
          </div>
          <h2
            data-testid="about-heading"
            className="font-serif-display text-[#EAEAEA] leading-[0.95] tracking-tighter text-5xl md:text-7xl lg:text-[6.5rem]"
          >
            Stories from the country
            <br />
            most people only <em className="text-[#C4A27A]">drive through</em>.
          </h2>
        </div>

        {/* Offset portrait — small, intentional */}
        <div className="md:col-span-4 md:col-start-1">
          <div className="img-zoom aspect-square w-full max-w-[280px] border border-white/10">
            <img
              src={profile?.headshot_url ? `${BACKEND_URL}/api/image-proxy?url=${encodeURIComponent(profile.headshot_url)}` : ""}
              alt={`${profile?.name} portrait`}
              data-testid="about-headshot"
              onError={(e) => {
                e.currentTarget.src =
                  "https://images.unsplash.com/photo-1513031300226-c8fb12de9ade?auto=format&fit=crop&w=900&q=80";
              }}
            />
          </div>
          {/* Inline stats — magazine-tag style */}
          <div className="mt-6 flex flex-wrap gap-x-5 gap-y-2 max-w-[280px]">
            <div className="text-xs">
              <span className="font-mono-overline text-[#C4A27A]/70">Outlet&nbsp;/</span>{" "}
              <span className="text-[#EAEAEA]/80">CBC News</span>
            </div>
            <div className="text-xs">
              <span className="font-mono-overline text-[#C4A27A]/70">Based&nbsp;/</span>{" "}
              <span className="text-[#EAEAEA]/80">Red Deer, Alta.</span>
            </div>
            <div className="text-xs">
              <span className="font-mono-overline text-[#C4A27A]/70">Beat&nbsp;/</span>{" "}
              <span className="text-[#EAEAEA]/80">Enterprise journalism</span>
            </div>
            <div className="text-xs">
              <span className="font-mono-overline text-[#C4A27A]/70">Formats&nbsp;/</span>{" "}
              <span className="text-[#EAEAEA]/80">Video, audio, digital</span>
            </div>
          </div>
        </div>

        {/* Bio body sits beside the portrait with deliberate breathing room */}
        <div className="md:col-span-7 md:col-start-6 md:pt-4">
          <p
            data-testid="about-bio"
            className="text-[#EAEAEA]/85 text-lg md:text-xl leading-[1.65] font-serif-display italic"
          >
            <span className="float-left font-serif-display not-italic text-[#C4A27A] text-6xl md:text-7xl leading-[0.85] mr-3 mt-1">
              {profile?.bio_long?.[0]}
            </span>
            {profile?.bio_long?.slice(1)}
          </p>
        </div>
      </div>
    </section>
  );
}
